export default "__VITE_ASSET__CfKTd$UY__"